var React = require('react');

function Discover (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M23.174 12.087C23.174 18.2095 18.209 23.174 12.087 23.174C5.965 23.174 1 18.2095 1 12.087C1 5.965 5.965 1 12.087 1C18.209 1 23.174 5.965 23.174 12.087Z","stroke":"#9F9EAD","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M19.9451 19.9438L31.0001 30.9988","stroke":"#9F9EAD","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Discover.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Discover;

Discover.default = Discover;
